import { clearDeviceDataFromSession, deleteRegisteredDevice, getDeviceIdFromSession, isDeviceValidatedInSession, setDeviceValidatedInSession, } from './deviceStorage';
export function isDeviceNotFoundError(error) {
    const deviceNotFoundMessages = [
        'DEVICE_NOT_FOUND',
        'Device not found',
        'Dispositivo não encontrado',
        'device not found',
    ];
    return deviceNotFoundMessages.some(message => error.message.toLowerCase().includes(message.toLowerCase()));
}
export function clearDeviceData() {
    clearDeviceDataFromSession();
}
export async function removeDeviceByPersonId(personId) {
    await deleteRegisteredDevice(personId);
}
export function isDeviceValid() {
    const deviceId = getDeviceIdFromSession();
    const isValidated = isDeviceValidatedInSession();
    return !!(deviceId && isValidated);
}
export function forceDeviceRevalidation() {
    setDeviceValidatedInSession(false);
}
